<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <small class="text-muted" style="font-size: 9px; margin-left: auto">{{ target.id }}</small>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxName">Metric Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxOwner">Who</label>
                    <wj-combo-box
                        [(ngModel)]="target.userId"
                        name="userId"
                        [itemsSource]="userMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="isCalculated">Is Calculated</label>
                    <wj-combo-box
                        id="isCalculated"
                        [(ngModel)]="target.isCalculated"
                        name="isCalculated"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="canEditHistorical">Can Edit Historical</label>
                    <wj-combo-box
                        id="canEditHistorical"
                        [(ngModel)]="target.canEditHistorical"
                        name="canEditHistorical"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="goalDirection">Goal Direction</label>
                    <wj-combo-box
                        [(ngModel)]="target.goalDirection"
                        name="goalDirection"
                        [itemsSource]="directionMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="format">Format</label>
                    <fa-icon
                        *ngIf="isAdding"
                        [icon]="faQuestionCircle"
                        style="margin-left: 5px; cursor: pointer"
                        title="Start with one of the following: N = Number, C = Currency, P = Percentage. Follow the letter with a number for the number of decimal places. Example: C2 = $123.45."
                    ></fa-icon>

                    <input id="format" type="text" class="form-control" [(ngModel)]="target.format" name="format" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="goal">Goal</label>
                    <input id="goal" type="number" class="form-control" [(ngModel)]="target.goal1" name="goal1" />
                </div>
            </div>
            <div class="col-6" [hidden]="target.goalDirection !== 2">
                <div class="form-group">
                    <label for="goal2">Between Goal 2</label>
                    <input id="goal2" type="number" class="form-control" [(ngModel)]="target.goal2" name="goal2" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="useRolling12Months">Average/Sum Calculated By</label>
                    <wj-combo-box
                        id="useRolling12Months"
                        [(ngModel)]="target.useRolling12Months"
                        name="useRolling12Months"
                        [itemsSource]="calcMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="showAverage">Show Average</label>
                    <wj-combo-box
                        id="showAverage"
                        [(ngModel)]="target.showAverage"
                        name="showAverage"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-3">
                <div class="form-group">
                    <label for="showSum">Show Sum</label>
                    <wj-combo-box
                        id="showSum"
                        [(ngModel)]="target.showSum"
                        name="showSum"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="isCalculated">Is Archived</label>
                    <wj-combo-box
                        id="isArchived"
                        [(ngModel)]="target.isArchived"
                        name="isArchived"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <textarea id="notes" rows="3" class="form-control" [(ngModel)]="target.notes" name="notes"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
